// extracted by mini-css-extract-plugin
module.exports = {"content":"aee5b7c44e--content--Bj0mq","description":"aee5b7c44e--description--SWDJ7","list":"aee5b7c44e--list--_OujL","list-item":"aee5b7c44e--list-item--J6DM8"};